module.exports = __webpack_public_path__ + "static/Matthieu_Hocquart-9ba4a82ed49fc5cebf73bf2ceb1fd756.webp";